import * as Yup from "yup";

const schema = Yup.object().shape({
    zonas_use_occupation_nome: Yup.string().required(
        "Nome do índice urbanístico é obrigatório"
    ),
    zonas_use_occupation_valor: Yup.string().required("Valor é obrigatório"),
    zonas_use_occupation_ordem: Yup.string().required(
        "Ordem de exibição é obrigatório"
    ),
    idzoneamento: Yup.string().required("ID do Zoneamento é obrigatório"),
});

export const zonesUseOccupationValidator = async (payload: unknown) => {
    await schema.validate(payload, {
        abortEarly: false,
    });
};
